import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ChangePasswordContainer.css';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

// Components
import ChangePasswordForm from '../../components/ChangePasswordForm';

class ChangePasswordContainer extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    registeredType: PropTypes.string
  };

  render() {
    const { title, registeredType } = this.props;
    const initialValues = { registeredType };

    return (
      <ChangePasswordForm initialValues={initialValues} />
    );
  }

}

const mapState = (state) => ({
  registeredType: state.account.data.userData.type,
});

const mapDispatch = {};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(ChangePasswordContainer)));
